import {
  ModalHeading,
  ModalDismiss,
  ModalContent,
  Modal,
  ModalHeader,
  ModalFooter,
  Text
} from '@vtex/shoreline'
import { t } from 'i18next'

import { Button } from '~/components/Buttons'

/** Confirmação no envio sem produtos vinculados (sem vínculo não há conversões/NCM). */
export const NoLinkedProductsConfirmationModal = ({
  isModalOpen,
  setIsModalOpen,
  formRef,
  isPending
}: NoLinkedProductsConfirmationModalProps) => (
  <Modal size="small" open={isModalOpen} onClose={() => setIsModalOpen(false)}>
    <ModalHeader>
      <ModalHeading style={{ fontSize: '1.25rem', fontWeight: 600, margin: 0 }}>
        {t('rm:campaign.create.noLinkedProductsModal.title')}
      </ModalHeading>
      <ModalDismiss size="large" />
    </ModalHeader>
    <ModalContent>
      <Text>{t('rm:campaign.create.noLinkedProductsModal.body')}</Text>
    </ModalContent>
    <ModalFooter style={{ justifyContent: 'center', borderTop: 'none' }}>
      <Button
        template="secondary"
        size="medium"
        onClick={() => setIsModalOpen(false)}
      >
        {t('rm:button.Cancel')}
      </Button>
      <Button
        template="primary"
        size="medium"
        type="button"
        loading={isPending}
        onClick={() => {
          formRef.current?.submitForm()
          setIsModalOpen(false)
        }}
      >
        {t('rm:campaign.create.noLinkedProductsModal.confirm')}
      </Button>
    </ModalFooter>
  </Modal>
)
